import { motion, AnimatePresence } from "motion/react";

export function CountdownItem({ value, label }) {
  return (
    <div className="min-w-[40px] rounded-xl bg-white/10 px-2 py-2 text-center ring-1 ring-white/15 backdrop-blur-xl sm:min-w-[50px] sm:rounded-2xl sm:px-3 sm:py-3 md:min-w-[60px] md:rounded-3xl md:px-4 md:py-4">
      <AnimatePresence mode="popLayout">
        <motion.span
          key={value}
          initial={{ y: 8, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -8, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="block text-lg font-semibold tabular-nums text-white sm:text-xl md:text-2xl lg:text-3xl"
        >
          {String(value).padStart(2, "0")}
        </motion.span>
      </AnimatePresence>

      <span className="mt-0.5 block text-[8px] font-semibold uppercase tracking-[0.12em] text-white/45 sm:mt-1 sm:text-[10px] sm:tracking-[0.15em] md:text-[11px] md:tracking-[0.18em]">
        {label}
      </span>
    </div>
  );
}